import React, {useContext, useEffect} from "react";
import {injectIntl} from "react-intl";
import {AutoRetrieverDeviceOverviewContext} from "./context/AutoRetrieverDeviceOverviewContext";
import {DraftContext} from "../../draftSave/context/DraftSaveContext";
import {
    CONFIG_TYPE, OPERATION_COLOR, PICK_STATION_STATUS,
    PICK_STATION_STATUS_COLOR, PICK_STATION_STATUSES
} from "../../util/Constants";
import {getLocalizedMessage} from "../../util/Localization";
import Loader from "@amzn/meridian/loader";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Select, {SelectOption} from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import Alert from "@amzn/meridian/alert";
import Text from "@amzn/meridian/text";

const DEFAULT_PICK_STATION_STATUS = PICK_STATION_STATUS.ENABLED;
const STATE_KEY = CONFIG_TYPE.PICK_STATION_CONFIGURATION;

const PickStationConfiguration = ({intl, selectedMac, isEditMode, setIsEditMode}) => {

    const {viewModel, dispatch} = useContext(AutoRetrieverDeviceOverviewContext);
    const {getDraftData, setDraftData, editInstance} = useContext(DraftContext);

    useEffect(() => {
        dispatch({type: "LOAD_PICK_STATION_RESOURCES", data: {dispatcher: dispatch}});
    }, []);

    useEffect(() => {
        if (selectedMac && viewModel.pickStationResources.length > 0) {
            initializeDraft();
        }
    }, [selectedMac, viewModel.pickStationResources, viewModel.timestamp]);

    const initializeDraft = () => {
        const mergedConfig = getMergedConfig();
        setDraftData({
            data: mergedConfig,
            stateKey: STATE_KEY,
            subKey: selectedMac
        });
    };

    const getMergedConfig = () => {
        const savedConfig = getSavedConfig();
        const savedConfigMap = {};
        savedConfig.forEach(item => {
            savedConfigMap[item.label] = item.status;
        });
        return viewModel.pickStationResources.map(resource => ({
            label: resource.label,
            status: savedConfigMap[resource.label] || DEFAULT_PICK_STATION_STATUS
        }));
    };

    const getSavedConfig = () => {
        if (!selectedMac) return [];
        const device = viewModel.autoRetrieverDeviceInformation[selectedMac];
        if (!device || !device.pickStationConfig) return [];
        return device.pickStationConfig;
    };

    const onClickEdit = () => {
        setIsEditMode(true);
    };

    const onStatusChange = (label, newStatus) => {
        editInstance({
            stateKey: STATE_KEY,
            subKey: selectedMac,
            instance: {label: label, status: newStatus},
            keyComparator: (a, b) => a.label === b.label,
            valueComparator: (a, b) => a.status === b.status
        });
    };

    if (viewModel.loadingPickStationResources) {
        return <Loader/>;
    }

    if (!selectedMac) {
        return null;
    }

    if (viewModel.pickStationResources.length === 0) {
        return (
            <Alert type="informational" size="small">
                {getLocalizedMessage({intl, stringId: "pickstation.no_resources"})}
            </Alert>
        );
    }

    const displayConfig = getDraftData({stateKey: STATE_KEY, subKey: selectedMac}) || [];

    return (
        <Column spacing="400">
            <Table
                headerRows={1}
                spacing="small"
                showDividers={true}>
                <TableRow highlightOnHover={false}>
                    <TableCell>
                        {getLocalizedMessage({intl, stringId: "pickstation.label"})}
                    </TableCell>
                    <TableCell>
                        {getLocalizedMessage({intl, stringId: "device.status"})}
                    </TableCell>
                </TableRow>
                {displayConfig.map((item) => (
                    <TableRow key={item.label} highlightOnHover={true}
                              backgroundColor={OPERATION_COLOR[item.operation]}>
                        <TableCell>
                            <Text type="b300"><b>{item.label}</b></Text>
                        </TableCell>
                        <TableCell>
                            {isEditMode ? (
                                <Select
                                    value={item.status}
                                    onChange={(value) => onStatusChange(item.label, value)}
                                    size="small"
                                    width={150}>
                                    {PICK_STATION_STATUSES.map(status => (
                                        <SelectOption key={status} value={status} label={status}/>
                                    ))}
                                </Select>
                            ) : (
                                <Text type="b300">
                                    <b style={{color: PICK_STATION_STATUS_COLOR[item.status]}}>
                                        {item.status}
                                    </b>
                                </Text>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </Table>
            {!isEditMode &&
                <Row spacing="300">
                    <Button type="primary" size="small" onClick={onClickEdit}>
                        {getLocalizedMessage({intl, stringId: "button.edit"})}
                    </Button>
                </Row>
            }
        </Column>
    );
};

export default injectIntl(PickStationConfiguration);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/PickStationConfiguration.js